import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Select,
  MenuItem,
  TextField,
  FormControl,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";

import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { keyframes } from "@mui/system";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { formatDateDDMMYYYY } from "utils/dateFormatter";

function AddoctorDocuments({ isOpen, onRequestClose, id, fetchCoordinator }) {
  const navigate = useNavigate();
 const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const [loading, setLoading] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [customersList, setCustomersList] = useState([]);
    const [errors, setErrors] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({
    doctorid: id,
    document: [
      {
        documentname: "",
        documenttype: "",
        dateofupload: getCurrentDate(),
        imageMeta: "",
        image: "",
        verified: false,
      },
    ],
  });

  // Add a new document block
  const handleAddDocument = () => {
    setCustomerDetails((prev) => ({
      ...prev,
      document: [
        ...prev.document,
        {
          documentname: "",
          documenttype: "",
        dateofupload: getCurrentDate(),
          imageMeta: "",
          image: "",
          verified: false,
        },
      ],
    }));
  };


     const validateDocuments = () => {
  let valid = true;

  const newErrors = customerDetails.document.map((doc) => {
    const docErrors = {};

    if (!doc.documentname || doc.documentname.trim() === "") {
      docErrors.documentname = "Document name is required.";
      valid = false;
    }

    if (!doc.imageMeta || !doc.image) {
      docErrors.image = "File upload is required.";
      valid = false;
    }

    return docErrors;
  });

  setErrors(newErrors);
  return valid;
};

const handleRemoveDocument = (index) => {
  const updatedDocs = [...customerDetails.document];
  updatedDocs.splice(index, 1);

  const updatedErrors = [...errors];
  updatedErrors.splice(index, 1);

  setCustomerDetails({
    ...customerDetails,
    document: updatedDocs,
  });

  setErrors(updatedErrors);
};
  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateDocuments()) {
    toast.error("Please fix the validation errors.");
    return;
  }

     setLoading(true);
   try {
         const secretKey = await fetchSecretKey();
   
        const filteredDocuments = customerDetails.document
         .filter(doc => doc.documentname && doc.documentname.trim() !== "") 
         .map(doc => ({
           doctorid: id,
           documentname: doc.documentname,
           documenttype: doc.documenttype || undefined, 
           dateofupload: formatDateDDMMYYYY(doc.dateofupload) || undefined,
           imageMeta: doc.imageMeta || undefined,
           image: doc.image || undefined,
          hospitalprofileid: customerDetails.hospitalprofileid,
         }));
   
       if (filteredDocuments.length === 0) {
         toast.error("Please add at least one document with a name.");
         setLoading(false);
         return;
       }
       console.log("secret key display",secretKey);
          const rawPayload = { document: filteredDocuments };
    console.log("Raw Payload Before Encryption:", rawPayload);
 
      const encryptedData = encryptBody(rawPayload, secretKey);
      console.log("Encrypted Payload:", encryptedData);

      const token = JSON.parse(localStorage.getItem("loginData")).token;

      const response = await axios.post(
        "/api/doctordocuments/create",
        encryptedData,
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);

        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }

        if (decryptedResponse.success === true) {
          toast.success(
            decryptedResponse.message || "Documents Added successfully!"
          );
          onRequestClose();
          if (typeof fetchCoordinator === "function") {
            fetchCoordinator();
           }
          setCustomersList((prev) => [...prev, customerDetails]);

          setCustomerDetails({
            doctorid: id,
            document: [
              {
                documentname: "",
                documenttype: "",
                dateofupload: "",
                imageMeta: "",
                image: "",
                verified: false,
              },
            ],
          });
        } else {
          toast.error(decryptedResponse?.message || "Failed.");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data || "Failed");
    } finally {
      setLoading(false);
    }
  };

  // Cancel handler
  const handleCancel = () => {
    setCustomerDetails({
      doctorid: id,
      document: [
        {
          documentname: "",
          documenttype: "",
          dateofupload: "",
          imageMeta: "",
          image: "",
          verified: false,
        },
      ],
    });
onRequestClose();
  };

  // Spinner animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                   backgroundColor: "#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      <Modal open={isOpen} onClose={onRequestClose}>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          p={2}
        >
          <Card
            sx={{
              width: { xs: "95%", sm: "90%", md: "800px" },
              padding: 3,
              margin: "auto",
              marginTop: "5vh",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <form onSubmit={handleSubmit}>
              <MDBox pt={4} pb={3} px={3}>
                <MDTypography variant="h6" mb={4} textAlign="center">
                  Add Documents:
                </MDTypography>

               

                {
                  customerDetails?.document.map((doc, index) => (
                    <Grid container spacing={2} key={index} mt={1}>
                      {/* Document Name */}
                      <Grid item xs={5}>
                        <TextField
                          select
                          label="Document Name"
                          fullWidth
                          value={doc.documentname}
                          onChange={(e) => {
                            const updatedDocs = [...customerDetails.document];
                            updatedDocs[index].documentname = e.target.value;

                            if (e.target.value === "Aadhar Card") {
                              updatedDocs[index].verified = false;
                            } else {
                              updatedDocs[index].verified = true;
                            }

                            setCustomerDetails({
                              ...customerDetails,
                              document: updatedDocs,
                            });
                          }}
                           sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
                        >
                          <MenuItem value="Aadhar Card">Aadhar Card</MenuItem>
                          <MenuItem value="Pan Card">Pan Card</MenuItem>
                          <MenuItem value="Driving License">
                            Driving License
                          </MenuItem>
                          {/* <MenuItem value="Study Certificate">
                            Study Certificate
                          </MenuItem> */}
                        </TextField>
                         {errors[index]?.documentname && (
                          <Typography sx={{ color: "red", fontSize: "12px" }}>
                            {errors[index].documentname}
                          </Typography>
                        )}
                      </Grid>

                      {/* Document Type */}
                      {/* <Grid item xs={6}>
                        <MDInput
                          label="Document Type"
                          fullWidth
                          value={doc.documenttype}
                          onChange={(e) => {
                            const updatedDocs = [...customerDetails.document];
                            updatedDocs[index].documenttype = e.target.value;
                            setCustomerDetails({
                              ...customerDetails,
                              document: updatedDocs,
                            });
                          }}
                        />
                      </Grid> */}

                      {/* Date of Upload */}
                      {/* <Grid item xs={6}>
                        <MDInput
                          type="date"
                          label="Date of Upload"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={doc.dateofupload}
                          onChange={(e) => {
                            const updatedDocs = [...customerDetails.document];
                            updatedDocs[index].dateofupload = e.target.value;
                            setCustomerDetails({
                              ...customerDetails,
                              document: updatedDocs,
                            });
                          }}
                        />
                      </Grid> */}

                      {/* File Upload */}
                     <Grid item xs={5}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.2,
      flexWrap: "wrap",
      p: 0,
    }}
  >
    {/* Choose File Button */}
    <label htmlFor={`file-upload-${index}`}>
      <input
        id={`file-upload-${index}`}
        accept="image/*,application/pdf,.doc,.docx"
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
              const updatedDocs = [...customerDetails.document];
              updatedDocs[index].imageMeta = file.name;
              updatedDocs[index].image = reader.result.split(",")[1];
              setCustomerDetails({
                ...customerDetails,
                document: updatedDocs,
              });
            };
            reader.readAsDataURL(file);
          }
        }}
      />
      <MDButton
        component="span"
        variant="outlined"
        sx={{
          textTransform: "none",
          color: "#1e6a91",
          borderColor: "#1e6a91",
          height: "40px",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Choose File
      </MDButton>
    </label>

    {/* File Link */}
    {doc.imageMeta && (
      <Typography
        sx={{
          color: "#1e6a91",
          cursor: "pointer",
          textDecoration: "underline",
          fontSize: "13px",
          flexShrink: 0,
        }}
        onClick={() => {
          const ext = doc.imageMeta.split(".").pop().toLowerCase();
          const byteCharacters = atob(doc.image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          let mimeType = "application/octet-stream";
          if (["jpg", "jpeg"].includes(ext)) mimeType = "image/jpeg";
          else if (ext === "png") mimeType = "image/png";
          else if (ext === "gif") mimeType = "image/gif";
          else if (ext === "pdf") mimeType = "application/pdf";
          else if (ext === "doc") mimeType = "application/msword";
          else if (ext === "docx")
            mimeType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          if (["jpg", "jpeg", "png", "gif", "pdf"].includes(ext)) {
            window.open(url, "_blank");
          } else {
            const a = document.createElement("a");
            a.href = url;
            a.download = doc.imageMeta;
            a.click();
          }
        }}
      >
        {doc.imageMeta}
      </Typography>
    )}

    {/* Delete Icon */}
    {doc.imageMeta && (
     <DeleteIcon
    size="small"
    color="error"
    sx={{
      fontSize: 13,
      cursor: "pointer",
      // "&:hover": { color: "red" },
    }}
        onClick={() => {
          const updatedDocs = [...customerDetails.document];
          updatedDocs[index].imageMeta = "";
          updatedDocs[index].image = "";
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        }}
      />
    )}
  </Box>
  {errors[index]?.image && (
  <Typography sx={{ color: "red", fontSize: "12px" }}>
    {errors[index].image}
  </Typography>
)}
</Grid>

{/* Remove Document (✖) aligned right) */}
<Grid item xs={2} textAlign="right">
  {customerDetails.document.length > 1 && index !== 0 && (
    <Typography
      onClick={() => handleRemoveDocument(index)}
      sx={{
        cursor: "pointer",
        color: "#f44335",
        fontSize: "13px",
        fontWeight: 900,
        lineHeight: 1,
        margin: "12px",
        "&:hover": { color: "#f44335" },
      }}
    >
      ✖
    </Typography>
    //  <MDButton
    //         variant="contained"
    //         color="error"
    //         size="small"
    //         sx={{
    //   background: "#f44335 !important",  // force override gradient bg
    //   color: "#fff !important",
    //   boxShadow: "none !important",
    //   "&:hover": {
    //     background: "#f44335 !important", // keep same color
    //     boxShadow: "none !important",
    //   },
    //   "&:focus": {
    //     background: "#f44335 !important",
    //     boxShadow: "none !important",
    //     outline: "none",
    //   },
    //   "&:active": {
    //     background: "#f44335 !important",
    //     boxShadow: "none !important",
    //   },
    // }}
    //         onClick={() => handleRemoveDocument(index)}
    //       >
    //         Remove
    //       </MDButton>
  )}
</Grid>

                      {/* Aadhaar Verification */}
                      {doc.documentname === "Aadhar Card" && !doc.verified && (
                        <Grid item xs={12}>
                          <MDButton
                            variant="outlined"
                            onClick={() => {
                              window.open(
                                "https://myaadhaar.uidai.gov.in/",
                                "_blank"
                              );

                              const updatedDocs = [...customerDetails.document];
                              updatedDocs[index].verified = true;
                              setCustomerDetails({
                                ...customerDetails,
                                document: updatedDocs,
                              });
                            }}
                            sx={{
                              background: "#2e7faeff",
                              color: "#fff",
                              "&:hover": { background: "#1e6a91" },
                              mt: 1,
                            }}
                          >
                            Verify Aadhaar
                          </MDButton>
                        </Grid>
                      )}
                    </Grid>
                  ))}

                <br/>
                  <Grid item xs={12}>
                   <MDButton
    variant="outlined"
    onClick={handleAddDocument}
    sx={{
      textTransform: "none",
      color: "#000",
      borderColor: "#000",
      backgroundColor: "transparent",
      height: 40,
        mt: 1,
      "&:hover": {
        backgroundColor: "#f0f0f0",
        borderColor: "#000",
      },
      "&:focus": {
        outline: "none",
      },
    }}
  >
    + Add Another Document
  </MDButton>
                  </Grid>
                
              </MDBox>

              <MDBox mt={2} textAlign="center">
                <MDButton
                  variant="gradient"
                  type="submit"
                 sx={{
      background: "#2e7faeff !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#2e7faeff !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
      },
    }}
                >
                  Submit
                </MDButton>
                &emsp;
                <MDButton
                  variant="gradient"
                  onClick={handleCancel}
                 sx={{
      background: "#2e7faeff !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#2e7faeff !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#2e7faeff !important",
        boxShadow: "none !important",
      },
    }}
                >
                  Cancel
                </MDButton>
              </MDBox>
            </form>
          </Card>
        </MDBox>
      </Modal>
    </DashboardLayout>
  );
}

export default AddoctorDocuments;
